<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let name = "";
	export let pointIsUsed = false;
	export let category: string[] = [];
	export let tId = "";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="container" t-id={tId}>
	<div class="category-name">{name}</div>
	<div class="category-wrapper">
		{#if pointIsUsed}
			{#each category as categoryName}
				<p class="value">{categoryName}</p>
			{/each}
		{:else}
			<p class="value">{'-'}</p>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		.category-name {
			color: #46474b;
		}
		.category-wrapper {
			display: flex;
			flex-wrap: wrap;
			gap: 20px;
			.value {
				font-weight: 500;
				color: #46474b;
			}
		}
	}

	@include DesktopSize {
		.container {
			.category-name {
				font-size: 1.25rem;
			}
			.category-wrapper {
				.value {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
